import { render } from "./ContactsList.vue?vue&type=template&id=5ec2ebd9"
import script from "./ContactsList.vue?vue&type=script&lang=js"
export * from "./ContactsList.vue?vue&type=script&lang=js"
script.render = render

export default script